import { render, staticRenderFns } from "./produceFooter.vue?vue&type=template&id=be60719a&scoped=true"
import script from "./produceFooter.vue?vue&type=script&lang=js"
export * from "./produceFooter.vue?vue&type=script&lang=js"
import style0 from "./produceFooter.vue?vue&type=style&index=0&id=be60719a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be60719a",
  null
  
)

export default component.exports